<template>
  <v-card outlined color="grey lighten-3">
    <v-toolbar dark dense flat :color="this.useApp == 'BIZPAY' ? 'cyan darken-3' : 'yellow'" class="font-weight-black">
      <v-icon :color="this.useApp == 'BIZPAY' ? 'indigo lighten-5' : 'black'" class="mr-3">mdi-credit-card-check</v-icon>
      <v-toolbar-title :class="{ 'black--text': this.useApp !== 'BIZPAY' }">결제정보</v-toolbar-title>
    </v-toolbar>

    <v-card-text class="mx-auto">
      <!-- 카드번호 -->
      <v-text-field
          dense filled type="tel" inputmode="numeric"
          label="카드번호" placeholder="XXXX-XXXX-XXXX-XXXX"
          hint="카드번호를 입력해주세요" color="pink"
          class="v-text-new1 font-weight-black"
          v-model="cardNumber" @input="onCardNumberInput" :maxlength="19"
      />

      <!-- 유효기간 -->
      <v-text-field
          dense filled type="tel" inputmode="numeric"
          label="유효기간" placeholder="MM/YY"
          hint="유효기간을 입력해주세요" color="pink"
          class="v-text-new1 font-weight-black"
          v-model="expiration" @input="onExpiryInput" :maxlength="5"
      />

      <!-- 비밀번호 앞 2자리 -->
      <v-text-field
          dense filled type="password" inputmode="numeric"
          label="비밀번호" placeholder="비밀번호 앞 2자리"
          hint="비밀번호를 입력해주세요" color="pink"
          class="v-text-new1 font-weight-black"
          v-model="passwd" :maxlength="2" @input="onPasswdInput"
      />

      <!-- 할부기간 -->
      <v-select
          class="v-text-new1 font-weight-black" dense filled
          :items="installmentItems" label="할부기간"
          item-text="text" item-value="value"
          v-model="installment" :disabled="installmentFlag"
          @change="onInstallmentChange"
      />

      <!-- BIZPAY 수기 인증 -->
      <template v-if="this.useApp === 'BIZPAY'">
        <template v-if="this.sugiCertification==='Y'">
          <v-text-field
              inputmode="numeric"
              label="생년월일(사업자번호)" filled
              class="v-text-new1 font-weight-black"
              v-model="pidNum" v-mask="'##########'"
              @input="emitFormPatch({ pidNum })"
              hint="610101(생년월일) 혹은 8208100121(사업자번호)"
          />
        </template>
      </template>

      <!-- SAFEPAY 연락처 -->
      <template v-else>

        <v-text-field
            filled label="생년월일"
            v-show="smsPaymentCertification === 'N' ? true : false"
            type="number"
            class="v-text-new1 font-weight-black"
            v-model="pidNum" v-mask="'##########'"
            @input="emitFormPatch({ pidNum })"
            hint="610101(생년월일)"
        />
        <v-text-field
            dense filled placeholder="핸드폰번호" label="연락처"
            v-model="mobilePhone" @input="onMobileInput"
            hint="기호 없이 숫자만 입력하세요" color="pink"
            class="v-text-new1 font-weight-black" v-mask="'###-####-####'"
            :disabled="smsPaymentCertification === 'Y' && linkType === 'N' ? true : isVerified"
            :readonly="smsPaymentCertification === 'Y' && linkType === 'N'"
        />
      </template>

      <!-- 받는사람 + 인증 -->
      <template v-if="useApp==='BIZPAY'">
        <v-text-field
            v-show="addrYn === 'Y'"
            filled color="pink" placeholder="성명"
            v-model="recipient" @input="onRecipientInput"
            hint="받으시는 분 이름을 입력하세요"
            class="v-text-new1 font-weight-black"
            :label="'받으시는분'"
        />
      </template>
      <template v-else>
        <v-text-field
            filled color="pink" placeholder="성명"
            v-model="recipient" @input="onRecipientInput"
            hint="받으시는 분 이름을 입력하세요"
            class="v-text-new1 font-weight-black"
            :label="smsPaymentCertification === 'Y' ? '성명(실명인증)' : '성명'"
            :readonly="useApp!=='BIZPAY' && smsPaymentCertification === 'Y'"
            :disabled="useApp!=='BIZPAY' && smsPaymentCertification === 'Y'"
        >
          <template v-if="this.smsPaymentCertification==='Y'" v-slot:append-outer>
            <v-btn
                :color="isVerified ? 'success' : 'primary'"
                @click="onVerify"
                height="56" min-width="auto"
                class="font-weight-black"
                style="margin-top: -17px;"
                :disabled="!isValidPhone || isVerified"
            >
              <template v-if="!isVerified">인증하기</template>
              <template v-else>인증완료</template>
            </v-btn>
          </template>
        </v-text-field>
      </template>


      <!-- 주소 -->
      <template v-if="addrYn==='Y'">
        <v-chip dark color="purple darken-3" label small class="mb-2" @click.stop="addrView=true">
          <v-icon small left>mdi-map-search-outline</v-icon>주소찾기
        </v-chip>

        <v-text-field dense filled label="우편번호" placeholder="우편번호"
                      v-model="zonecode" color="pink" class="v-text-new1 font-weight-black"
                      hint="주소찾기를 통해서도 가능합니다." @input="onAddrChange"
        />
        <v-text-field dense filled label="주소" placeholder="주소를 직접입력하거나 찾기 버튼을 선택하세요"
                      v-model="addrInfo" color="pink" class="v-text-new1 font-weight-black"
                      hint="주소를 직접입력하거나 찾기 버튼을 선택하세요" @input="onAddrChange"
        />
        <v-text-field dense filled label="상세주소" placeholder="예) 101동 101호"
                      v-model="addrDetailInfo" color="pink" class="v-text-new1 font-weight-black"
                      hint="추가 주소 정보를 입력하세요" @input="onAddrChange"
        />
        <v-textarea v-model="message" color="pink" filled label="요청사항" class="v-text-new1 font-weight-black" @input="onMessageChange" />
      </template>
    </v-card-text>

    <Address :addrView='this.addrView' @addrViewEvent='this.addrViewEvent' />
  </v-card>
</template>

<script>
import Address from "@/components/sms/address.vue";

export default {
  components: { Address },
  props: {
    id: String,
    useApp: String,
    mberCode: String,
    linkType: { type: String, default: 'N'},
    mberMobile: { type: String, default: "" },
    installmentMonths: { type: Number, default: 0 },
    sugiCertification: { type: String, default: 'N' },
    smsPaymentCertification: { type: String, default: 'N' },
    addrYn: { type: String, default: 'N' },
    value: { type: Object, required: true } // v-model: payRequest
  },
  data() {
    return {
      addrView: false,
      cardNumber: '',
      installment: "00",
      expiration: '',
      pidNum: '',
      passwd: '',
      zonecode: '',
      addrInfo: '',
      addrDetailInfo: '',
      recipient: '',
      mobilePhone: '',
      message: '',
      tid: '',
      ci: '',
      di: '',
      iden: '',
      isVerified: false
    };
  },
  created() {
    // 부모 초기값을 자식 로컬 필드에 주입 (새로고침/복귀 대비)
    const v = this.value || {};
    this.cardNumber     = v.cardNumber     || '';
    this.expiration     = v.expiration     || '';
    this.passwd         = v.passwd         || '';
    this.installment = v.installment || "00";
    this.pidNum         = v.pidNum         || '';
    this.recipient      = v.recipient      || '';
    this.mobilePhone    = v.mobilePhone || this.mberMobile || '';
    this.zonecode       = v.zonecode       || '';
    this.addrInfo       = v.addrInfo       || '';
    this.addrDetailInfo = v.addrDetailInfo || '';
    this.tid            = v.tId || v.tid || '';
    this.iden = v.iden     || '';
    this.totAmt = v.totAmt || 0;

  },
  watch: {
    // 부모가 바깥에서 payRequest를 갱신한 경우 자식도 반영
    value: {
      deep: true,
      handler(v) {
        if (!v) return;
        this.cardNumber     = v.cardNumber     ?? this.cardNumber;
        this.expiration     = v.expiration     ?? this.expiration;
        this.passwd         = v.passwd         ?? this.passwd;
        this.installment    = v.installment    ?? this.installment;
        this.pidNum         = v.pidNum         ?? this.pidNum;
        this.recipient      = v.recipient      ?? this.recipient;
        this.mobilePhone    = v.mobilePhone    ?? this.mberMobile;
        this.zonecode       = v.zonecode       ?? this.zonecode;
        this.addrInfo       = v.addrInfo       ?? this.addrInfo;
        this.addrDetailInfo = v.addrDetailInfo ?? this.addrDetailInfo;
        this.totAmt = v.totAmt ?? this.totAmt;
        // 인증 상태도 필요하면 동기화
        if (typeof v.isVerified === 'boolean') this.isVerified = v.isVerified;
      }
    },
    // 휴대폰이 변경되면 인증완료 해제 + 부모에도 반영
    mobilePhone(newVal, oldVal) {
      const dn = (newVal || '').replace(/\D/g, '');
      const do_ = (oldVal || '').replace(/\D/g, '');
      if (dn !== do_) {
        this.isVerified = false;
        this.emitFormPatch({ mobilePhone: dn, isVerified: false });
      }
    }
  },
  computed: {
    installmentItems() {
      const arr = [];
      for (let i = 0; i <= this.installmentMonths; i++) {
        if (i === 0) arr.push({ text: "일시불", value: "00" });
        else if (i === 1) continue;
        else if (i < 10) arr.push({ text: `${i} 개월`, value: `0${i}` });
        else arr.push({ text: `${i} 개월`, value: String(i) });
      }
      return arr;
    },
    isValidPhone() {
      const digits = (this.mobilePhone || '').replace(/\D/g, '');
      return digits.length === 10 || digits.length === 11;
    },
    // 할부 선택 가능유무
    installmentFlag(){
      if(!this.installmentMonths) return true;
      if(this.installmentMonths <2) return true;
      return this.totAmt < 50000;

    },

  },
  mounted() {
    window.addEventListener('message', this.onUasMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onUasMessage);
  },
  methods: {
    emitFormPatch(patch = {}) {
      this.$emit('input', { ...this.value, ...patch });
    },

    onCardNumberInput(e) {
      const raw = (e?.target?.value ?? this.cardNumber) || '';
      const digits = raw.replace(/\D/g, '').slice(0, 16);
      const formatted = digits.match(/.{1,4}/g)?.join('-') ?? '';
      this.cardNumber = formatted;
      this.emitFormPatch({ cardNumber: formatted });
    },

    onExpiryInput(e) {
      const raw = (e?.target?.value ?? this.expiration) || '';
      let digits = raw.replace(/\D/g, '').slice(0, 4);
      if (digits.length >= 2) {
        let month = parseInt(digits.slice(0,2), 10);
        if (month === 0) month = 1;
        else if (month > 12) month = 12;
        digits = month.toString().padStart(2, '0') + digits.slice(2);
      }
      const formatted = digits.length >= 3 ? digits.slice(0,2) + '/' + digits.slice(2) : digits;
      this.expiration = formatted;
      this.emitFormPatch({ expiration: formatted });
    },

    onPasswdInput(v) {
      this.passwd = typeof v === 'string' ? v : this.passwd;
      this.emitFormPatch({ passwd: this.passwd });
    },

    onInstallmentChange(v) {
      this.installment = v;
      this.emitFormPatch({ installmentMonths: v });
    },

    onRecipientInput(v) {
      this.recipient = v;
      this.emitFormPatch({ recipient: v });
    },

    onMobileInput(v) {
      this.mobilePhone = v;
      this.emitFormPatch({ mobilePhone: v.replace(/\D/g, '') });
    },

    onAddrChange() {
      this.emitFormPatch({
        addrInfo: this.addrInfo,
        addrDetailInfo: this.addrDetailInfo,
        zonecode: this.zonecode
      });
    },

    onMessageChange() {
      this.emitFormPatch({ message: this.message });
    },

    addrViewEvent(obj) {
      this.addrView = false;
      if (obj) {
        this.addrInfo = obj.address;
        this.zonecode = obj.zonecode;
        this.onAddrChange(); // 선택 즉시 부모 반영
      }
    },

    onVerify() {
      if (!this.isValidPhone || this.isVerified) return;

      const win = window.open('', 'verifyWin', 'width=480,height=720');
      if (!win) {
        this.isVerified = false;
        this.emitFormPatch({ isVerified: false });
        alert('팝업이 차단되었습니다. 팝업 허용 후 다시 시도하세요.');
        return;
      }

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://api.uni-core.co.kr/identity/uas'; // 운영 URL로 교체
      form.target = 'verifyWin';

      const set = (name, val) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = val ?? '';
        form.appendChild(input);
      };

      set('IsDstAddr', this.mobilePhone.replace(/\D/g, ''));
      set('orderId', this.id);
      set('userId', this.mberCode);

      set('useApp', this.useApp);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);

      const allowedOrigin = '*'; // 운영에서는 정확한 도메인으로 제한하세요.
      const onMessage = (e) => {
        if (allowedOrigin !== '*' && e.origin !== allowedOrigin) return;

        const { type, data } = e.data || {};
        if (type === 'UAS_SUCCESS') {
          // 비즈니스 처리
          this.isVerified = (data?.code === '0000');
          this.emitFormPatch({ isVerified: this.isVerified });

          // 팝업 닫기(부모가 닫는 폴백: iOS 대응)
          try { this.verifyWin && this.verifyWin.close(); } catch (_) {}
          // iOS 일부 환경에서 close가 무시되면 about:blank 로 교체 후 닫기 재시도
          try {
            if (this.verifyWin && !this.verifyWin.closed) {
              this.verifyWin.location.replace('about:blank');
              setTimeout(() => { try { this.verifyWin.close(); } catch(_) {} }, 50);
            }
          } catch (_) {}

          window.removeEventListener('message', onMessage);
        }
      };
      window.addEventListener('message', onMessage);

      // 5) 사용자가 팝업을 수동으로 닫았을 때를 감지(선택)
      const checker = setInterval(() => {
        if (!this.verifyWin || this.verifyWin.closed) {
          clearInterval(checker);
          window.removeEventListener('message', onMessage);
        }
      }, 500);
    },

    onUasMessage(event) {
      // 운영환경에서는 event.origin 화이트리스트로 필터링 권장
      const payload = event.data;
      if (!payload || payload.type !== 'UAS_SUCCESS') return;

      const d = payload.data || {};
      this.tid   = d.tid  || '';
      this.ci    = d.ci   || '';
      this.di    = d.di   || '';
      this.iden  = d.iden || '';
      this.recipient = d.name || '';
      this.pidNum = this.iden.substring(0,6);

      this.isVerified = true;

      // 부모에도 전부 반영
      this.emitFormPatch({
        tId: this.tid, tid: this.tid, // 부모 키가 tId면 같이 올려줌
        ci: this.ci,
        di: this.di,
        pidNum: this.pidNum,
        recipient: this.recipient,
        isVerified: true,
        iden: this.iden,
      });

      this.$emit('uas-success', { tid: this.tid, ci: this.ci, di: this.di, iden: this.iden });
    }
  }
};
</script>